import { Dropdown, Button } from "antd";
import { useTranslation } from "react-i18next";
import { GlobalOutlined } from "@ant-design/icons";

const LANGUAGE_OPTIONS: Array<{ key: string; label: string }> = [
  { key: "en", label: "🇬🇧 English" },
  { key: "es", label: "🇪🇸 Español" },
  { key: "it", label: "🇮🇹 Italiano" },
  { key: "pt", label: "🇵🇹 Português" },
  { key: "es-PE", label: "🇵🇪 Español (Perú)" },
  { key: "es-CL", label: "🇨🇱 Español (Chile)" },
  { key: "es-UY", label: "🇺🇾 Español (Uruguay)" },
];

/**
 * Language Selector — switches the UI locale in-session.
 * Persists the choice in localStorage; the user's profile-level preference
 * is stored separately (PATCH /api/auth/me/) and applied on next login.
 */
export const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const handleChange = (value: string) => {
    i18n.changeLanguage(value);
    localStorage.setItem("language", value);
  };

  return (
    <Dropdown
      menu={{
        items: LANGUAGE_OPTIONS.map((opt) => ({
          key: opt.key,
          label: opt.label,
          onClick: () => handleChange(opt.key),
        })),
        selectedKeys: [i18n.language],
      }}
    >
      <Button type="text" icon={<GlobalOutlined />} />
    </Dropdown>
  );
};
